import React from 'react';
import './style.scss';
import useClientsAddPartner from './hooks';
import Form from '../../../../../components/molecules/forms';
import { DollarSign, Percentage } from '../../../../../components/atoms/icons';
import Button from '../../../../../components/molecules/buttons';
import CommissionType from '../../utils/commission-type';

interface Props {
  // eslint-disable-next-line react/require-default-props
  formikClient?: any;
  // eslint-disable-next-line react/require-default-props
  clientPartnerId?: number | null;
}

function ClientsAddPartner(props: Props) {
  const { formikClient, clientPartnerId } = props;
  const {
    partnerId, currentMode, setCurrentMode, partnerList, partnersLoading, formik,
    onCancelNavigate, clientById, updateLoading,
  } = useClientsAddPartner(formikClient, clientPartnerId);

  const renderForm = () => (
    <div className="row">
      <div className="col-lg-4">
        <Form.ReactSelect.Default
          id="partnerId"
          placeholder="Partner name"
          label="Search or choose a partner"
          disabled={partnersLoading}
          options={partnerList}
          value={partnerList.find((partner) => partner.value.toString() === formik.values.partnerId?.toString())}
          onChange={(e) => {
            if (e) formik.setFieldValue('partnerId', e.value);
          }}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.partnerId && formik.touched.partnerId}
          errorMsg={formik.errors.partnerId}
          className="mb-4"
        />
      </div>
      <div className="col-lg-4">
        <CommissionType currentMode={currentMode} setCurrentMode={setCurrentMode} />
      </div>
      <div className="col-lg-4">
        <Form.DefaultWithIcon
          id="partnerCommission"
          placeholder="Enter commision"
          className="mb-4"
          label="Enter Commision"
          type="number"
          rightIcon={currentMode === 1 ? <Percentage width={23} /> : <DollarSign width={23} />}
          value={formik.values.partnerCommission}
          onChange={formik.handleChange}
          isInvalid={!!formik.errors.partnerCommission && formik.touched.partnerCommission}
          errorMsg={formik.errors.partnerCommission}
          onBlur={formik.handleBlur}
        />
      </div>
      <div className={formikClient ? 'd-none' : 'd-flex justify-content-end align-self-end mt-5'}>
        <div style={clientPartnerId ? { display: 'none' } : { width: '200px', marginRight: '20px' }}>
          <Button.Default
            id="cancel"
            type="button"
            label="Cancel"
            size="lg"
            outline
            onClick={onCancelNavigate}
          />
        </div>
        <div style={{ width: '200px' }}>
          <Button.Default
            id="save"
            type="submit"
            label="Save Changes"
            size="lg"
            loading={updateLoading}
            disabled={!clientById}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="px-4 px-xl-5">
      <div className="fw-bold fz-14 mb-4" style={{ marginLeft: '20px' }}>
        {`${partnerId ? 'Edit' : 'Add'} Partner${formikClient ? '(Optional)' : ''}`}
      </div>
      {!formikClient ? (
        <form onSubmit={formik.handleSubmit}>
          {renderForm()}
        </form>
      ) : (<div>{renderForm()}</div>)}
    </div>
  );
}

export default ClientsAddPartner;
